








































































import { Component, Ref } from 'nuxt-property-decorator'
import { ModalComponentBaseVue } from '@/base'
import {
  Alert,
  AlertMessage,
  bibliographyRealApi,
  BibliographySearchResultItem,
  defaultSystemCode,
  ErrorMessage,
  reserveApi,
  ReserveGroupReserve,
  ReserveSetReserve,
  SimpleBibliographyReal
} from '@/api'
import {
  NAV_LOADING_END,
  NAV_LOADING_START,
  PAGE_LOADING_END,
  PAGE_LOADING_START
} from '@/config/event'
import {
  alertStore,
  modalBibliographyDetailRealStore,
  modalBibliographyDetailSetStore,
  modalBibliographySearchResultStore,
  modalBibliographySearchStore,
  modalErrorStore
} from '@/utils/store-accessor'
import { ModalFooter } from '@/components/molecules/ModalFooter'
import {
  ReserveSetGroupEditTable,
  ReserveSetGroupEditTableItem
} from '@/components/organisms/ReserveSetGroupEditTable'
import {
  AlertCodeAL300051,
  AlertCodeALC00007,
  AlertCodeILC00005,
  AlertCodeILC00031,
  AlertCodeTLC00003,
  AuthoritySearchType,
  BibliographyDetailRealTabType,
  BibliographyDetailSetTabType,
  BibliographyFullId,
  BibliographyFullIdWithMarcNo,
  Prefix,
  ReserveType,
  SearchType
} from '@/types'
import {
  ReserveSetGroupEditInfo,
  defaultReserveSetGroupEditInfoItem,
  ReserveSetGroupEditInfoItem
} from '@/components/organisms/ReserveSetGroupEditInfo'
import { SelectBibliographyDetailReal } from '@/store/ModalBibliographyDetailRealStore'
import { AlertFactory } from '@/factory'
import { ModalReserveCancel } from '@/components/modals/ModalReserveCancel'

interface ModalReserveSetGroupEditInterface {
  reserveType: ReserveType
  reserveSetGroupId: number
  userId: string
  bibliographyRealId: number
  onRegistered?: () => void
  onReserveCanceled?: () => void
}

@Component({
  components: {
    ModalReserveCancel,
    ReserveSetGroupEditInfo,
    ReserveSetGroupEditTable,
    ModalFooter
  }
})
export default class ModalReserveSetGroupEdit extends ModalComponentBaseVue {
  @Ref()
  modalReserveCancel!: ModalReserveCancel

  dialog: boolean = false

  tableBodyHeight: number = 0

  infoItem: ReserveSetGroupEditInfoItem = defaultReserveSetGroupEditInfoItem()

  tableItems: ReserveSetGroupEditTableItem[] = []

  reserveType: ReserveType = ReserveType.Set

  userId: string = ''

  bibliographyRealId: number = 0

  reserveSetGroups: (ReserveSetReserve | ReserveGroupReserve)[] = []

  reserveSetGroupId: number = 0

  registeredCallback?: () => void

  reserveCanceledCallback?: () => void

  isAllSelect: boolean = false

  get activeRowIndex(): number {
    return this.tableItems.findIndex(
      item => item.bibliographyRealId === this.bibliographyRealId
    )
  }

  get isReserveTypeSet(): boolean {
    return this.reserveType === ReserveType.Set
  }

  get isHitOneSearchResults(): boolean {
    return modalBibliographySearchStore.total === 1
  }

  get searchResults(): BibliographySearchResultItem[] {
    return modalBibliographySearchStore.items
  }

  get existsReserveSetRank(): boolean {
    return (this.reserveSetGroups as ReserveSetReserve[]).some(
      item => item.reserveSetRank > 0
    )
  }

  get existsReturnWaitingReserve(): boolean {
    return this.reserveSetGroups.some(
      reserveSetGroup => reserveSetGroup.reserveStatus.code === '4'
    )
  }

  async open(params: ModalReserveSetGroupEditInterface): Promise<void> {
    this.dialog = true
    this.reserveType = params.reserveType
    this.reserveSetGroupId = params.reserveSetGroupId
    this.userId = params.userId
    this.bibliographyRealId = params.bibliographyRealId
    this.registeredCallback = params.onRegistered
    this.reserveCanceledCallback = params.onReserveCanceled

    try {
      await this.getReserveSetGroup()

      const reserveSetRanks = this.reserveSetGroups
        .filter(
          value =>
            value.reserveStatus.code !== '4' &&
            (value as ReserveSetReserve).reserveSetRank
        )
        .map(value => (value as ReserveSetReserve).reserveSetRank)

      this.tableItems = this.reserveSetGroups.reduce(
        (
          accum: ReserveSetGroupEditTableItem[],
          current: ReserveSetReserve | ReserveGroupReserve
        ) => {
          let reserveSetRank = 0

          if (this.isReserveTypeSet) {
            // 返却待ち以外の予約の順位は保持するようにしている
            // 順序性無しから新たに設定を行う場合、返却待ち以外の予約の順位と重複しないようにする
            if ((current as ReserveSetReserve).reserveSetRank === 0) {
              reserveSetRank =
                reserveSetRanks.length > 0
                  ? Math.max(...reserveSetRanks) + 1
                  : 1

              while (
                accum
                  .map(
                    (value: ReserveSetGroupEditTableItem) =>
                      value.reserveSetRank
                  )
                  .includes(reserveSetRank)
              ) {
                reserveSetRank++
              }
            } else {
              reserveSetRank = (current as ReserveSetReserve).reserveSetRank
            }
          }

          accum.push({
            isSelected: false,
            isNewAddReserve: false,
            id: current.id,
            bibliographyRealId: current.bibliographyRealId,
            bibliographyClass: current.bibliographyClass,
            prefix: current.prefix,
            searchType: current.searchType,
            reserveSetRank,
            displayTitle: current.displayTitle,
            displayAuthor: current.displayAuthor,
            displayPublisher: current.displayPublisher,
            displayPublished: current.displayPublished,
            displaySize: current.displaySize,
            collectionFlag: current.collectionFlag,
            reserveStatus: current.reserveStatus,
            revision: current.revision
          })

          return accum
        },
        []
      )

      this.infoItem.hasRank.input =
        this.isReserveTypeSet &&
        (this.reserveSetGroups.some(
          (reserveSetGroup: any) =>
            reserveSetGroup.reserveStatus.code === '4' &&
            reserveSetGroup.reserveSetRank > 0
        ) ||
          (this.reserveSetGroups.every(
            (reserveSetGroup: any) =>
              reserveSetGroup.reserveStatus.code !== '4' &&
              reserveSetGroup.reserveSetRank > 0
          ) &&
            this.reserveSetGroups.some(
              (reserveSetGroup: any) => reserveSetGroup.reserveSetRank > 0
            )))
    } catch (e) {
      this.close()
    }
    window.addEventListener('resize', this.calculateTableHeight)

    this.$nextTick(this.calculateTableHeight)
  }

  close(): void {
    this.dialog = false
    this.initialize()
    window.removeEventListener('resize', this.calculateTableHeight)
  }

  initialize(): void {
    this.infoItem = defaultReserveSetGroupEditInfoItem()
    this.tableItems = []
    this.reserveType = ReserveType.Set
    this.userId = ''
    this.bibliographyRealId = 0
    this.reserveSetGroups = []
    this.reserveSetGroupId = 0
    this.registeredCallback = undefined
    this.reserveCanceledCallback = undefined
    this.isAllSelect = false
  }

  calculateTableHeight(): void {
    this.tableBodyHeight = 0

    this.$nextTick(() => {
      this.tableBodyHeight = this.calculateTableHeightBase()
    })
  }

  print(): void {
    const element = document.getElementById('modal-reserve-set-group-edit')
    if (element) {
      this.$webSocket.sendDialogScreenshotMessage(element)
    } else {
      this.$webSocket.sendScreenshotMessage()
    }
  }

  onClickDelete(): void {
    const checkedTableItems: ReserveSetGroupEditTableItem[] = this.tableItems.filter(
      value => value.isSelected
    )

    if (checkedTableItems.length === 0) {
      alertStore.setItem(
        AlertFactory.create(
          AlertCodeILC00005,
          '削除',
          (this.isReserveTypeSet ? 'セット' : 'グループ') + '予約情報'
        )
      )
      this.$modalAlert.open()
      return
    }

    alertStore.setItem(AlertFactory.create(AlertCodeAL300051))
    this.$modalAlert.open({
      onOkClick: () => {
        this.modalReserveCancel.open({
          reserveCancelCollections: checkedTableItems.map(value => {
            return {
              reserveId: value.id,
              revision: value.revision
            }
          }),
          onReserveCanceled: async () => {
            if (this.reserveCanceledCallback) {
              this.reserveCanceledCallback()
            }

            if (
              this.tableItems.filter(item => item.isSelected).length ===
              this.tableItems.length
            ) {
              this.close()
              return
            }

            try {
              await this.getReserveSetGroup()
              const checkedItems = this.tableItems.filter(
                item => item.isSelected
              )
              this.tableItems = this.tableItems.filter(item => !item.isSelected)
              this.tableItems.forEach(item => {
                this.reserveSetGroups.forEach(reserveSetGroup => {
                  if (reserveSetGroup.id === item.id) {
                    item.revision = reserveSetGroup.revision
                  }
                })
                if (this.isReserveTypeSet) {
                  let decrementCount: number = 0
                  checkedItems.forEach(checkedItem => {
                    if (checkedItem.reserveSetRank < item.reserveSetRank) {
                      decrementCount++
                    }
                  })

                  item.reserveSetRank -= decrementCount
                }
              })
            } catch (e) {}
          }
        })
      }
    })
  }

  onClickRegister(): void {
    alertStore.setItem(
      AlertFactory.create(
        AlertCodeALC00007,
        (this.isReserveTypeSet ? 'セット' : 'グループ') + '予約',
        '登録'
      )
    )
    this.$modalAlert.open({
      onOkClick: this.updateReserveSetGroup
    })
  }

  removeTableItem(index: number): void {
    this.tableItems.splice(index, 1)
  }

  toggleAllSelect(): void {
    this.isAllSelect = !this.isAllSelect

    this.tableItems.forEach(item => {
      if (!item.isNewAddReserve) {
        item.isSelected = this.isAllSelect
      }
    })
  }

  onClickRow(index: number): void {
    if (!this.tableItems[index].isNewAddReserve) {
      this.tableItems[index].isSelected = !this.tableItems[index].isSelected
    }
  }

  validateSelectBibliographyId(
    bibliographyFullIdsWithMarcNo: BibliographyFullIdWithMarcNo[]
  ): void {
    const alerts: Alert[] = []

    if (
      bibliographyFullIdsWithMarcNo.some(value => value.prefix !== Prefix.Real)
    ) {
      alerts.push(
        AlertFactory.create(
          AlertCodeTLC00003,
          '書誌階層が物理書誌以外',
          '予約候補リストへの追加'
        )
      )
    }

    if (
      this.tableItems.some(item =>
        bibliographyFullIdsWithMarcNo.some(
          value =>
            item.prefix === value.prefix && item.bibliographyRealId === value.id
        )
      )
    ) {
      alerts.push(AlertFactory.create(AlertCodeILC00031, '書誌'))
    }

    if (alerts.length > 0) {
      alertStore.setItems(alerts)
      this.$modalAlert.open()
      return
    }

    this.getSimpleBibliographyReal(
      bibliographyFullIdsWithMarcNo.map(value => value?.id ?? 0)
    )
  }

  async getReserveSetGroup(): Promise<void> {
    this.$eventBus.emit(NAV_LOADING_START)

    try {
      if (this.isReserveTypeSet) {
        this.reserveSetGroups = await reserveApi.getReserveSetReserve({
          userId: this.userId,
          reserveSetId: this.reserveSetGroupId
        })
      } else {
        this.reserveSetGroups = await reserveApi.getReserveGroupReserve({
          userId: this.userId,
          reserveGroupId: this.reserveSetGroupId
        })
      }
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }

      throw error
    } finally {
      this.$eventBus.emit(NAV_LOADING_END)
    }
  }

  async updateReserveSetGroup(): Promise<void> {
    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      if (this.isReserveTypeSet) {
        await reserveApi.updateReserveSetReserve({
          userId: this.userId,
          reserveSetId: this.reserveSetGroupId,
          reserves: this.tableItems.map(item => {
            return {
              id: item.id,
              bibliographyRealId: item.bibliographyRealId,
              reserveSetRank: this.infoItem.hasRank.input
                ? item.reserveSetRank
                : 0,
              revision: item.revision
            }
          })
        })
      } else {
        await reserveApi.updateReserveGroupReserve({
          userId: this.userId,
          reserveGroupId: this.reserveSetGroupId,
          reserves: this.tableItems.map(item => {
            return {
              id: item.id,
              bibliographyRealId: item.bibliographyRealId,
              revision: item.revision
            }
          })
        })
      }

      if (this.registeredCallback) {
        this.registeredCallback()
      }

      this.close()
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  // 多数追加する可能性は少ないと判断して、とりあえず複数回簡易書誌を呼び出す作りとする
  // 作りとしてはレファレンスの更新と同様のことをしている
  async getSimpleBibliographyReal(
    bibliographyRealIds: number[]
  ): Promise<void> {
    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      const responses: SimpleBibliographyReal[] = await Promise.all(
        bibliographyRealIds.map(id => {
          return bibliographyRealApi.getSimpleBibliographyReal(id)
        })
      )

      const reserveSetRanks = this.tableItems.map(value => value.reserveSetRank)

      this.tableItems.push(
        ...responses.reduce(
          (
            accum: ReserveSetGroupEditTableItem[],
            current: SimpleBibliographyReal
          ) => {
            let reserveSetRank = 0

            if (this.isReserveTypeSet) {
              reserveSetRank =
                reserveSetRanks.length > 0
                  ? Math.max(...reserveSetRanks) + 1
                  : 1

              while (
                accum
                  .map(
                    (value: ReserveSetGroupEditTableItem) =>
                      value.reserveSetRank
                  )
                  .includes(reserveSetRank)
              ) {
                reserveSetRank++
              }
            }

            accum.push({
              isSelected: false,
              isNewAddReserve: true,
              id: 0,
              bibliographyRealId: current.bibliographyId,
              bibliographyClass: current.bibliographyClass,
              prefix: current.prefix,
              searchType: current.searchType.code as SearchType,
              reserveSetRank,
              displayTitle: current.displayTitle,
              displayAuthor: current.displayAuthor,
              displayPublisher: current.displayPublisher,
              displaySize: current.displaySize,
              displayPublished: current.displayPublished,
              collectionFlag: current.collectionFlag,
              reserveStatus: defaultSystemCode(),
              revision: 1
            })

            return accum
          },
          []
        )
      )

      // 全ての処理が終了した段階で資料関連ダイアログを閉じる
      modalBibliographySearchResultStore.close()
      modalBibliographyDetailRealStore.close()
      modalBibliographyDetailSetStore.close()
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  // ここから資料検索ダイアログ、資料検索結果ダイアログ、資料照会ダイアログの制御記述
  openModalBibliographySearchCondition(isBack: boolean = false): void {
    this.$modalBibliographySearchCondition.open({
      isBack,
      onSearch: () => {
        if (this.isHitOneSearchResults) {
          this.openModalBibliographyDetail(
            true,
            this.searchResults[0].prefix,
            this.searchResults[0].bibliographyId,
            this.openModalBibliographySearchResult
          )
          return
        }
        this.openModalBibliographySearchResult()
      },
      onSearchAuthority: () => {
        if (
          modalBibliographySearchStore.authoritySearchType ===
          AuthoritySearchType.ContentAuthor
        ) {
          if (modalBibliographySearchStore.contentItems.length === 1) {
            this.openModalBibliographyDetail(
              true,
              modalBibliographySearchStore.contentItems[0].prefix,
              modalBibliographySearchStore.contentItems[0]?.bibliographyId ?? 0,
              this.openModalBibliographySearchResultContent,
              '',
              modalBibliographySearchStore.contentItems[0]
                ?.bibliographyContentId ?? 0
            )
          } else if (modalBibliographySearchStore.authorityItems.length === 1) {
            this.openModalBibliographySearchResultContent()
          } else {
            this.openModalBibliographySearchResultAuthority()
          }
        } else if (this.isHitOneSearchResults) {
          this.openModalBibliographyDetail(
            true,
            this.searchResults[0].prefix,
            this.searchResults[0].bibliographyId,
            this.openModalBibliographySearchResult
          )
        } else if (modalBibliographySearchStore.authorityItems.length === 1) {
          this.openModalBibliographySearchResult()
        } else {
          this.openModalBibliographySearchResultAuthority()
        }
      },
      onSearchContent: () => {
        if (modalBibliographySearchStore.contentItems.length === 1) {
          this.openModalBibliographyDetail(
            true,
            modalBibliographySearchStore.contentItems[0].prefix,
            modalBibliographySearchStore.contentItems[0].bibliographyId,
            this.openModalBibliographySearchResultContent,
            '',
            modalBibliographySearchStore.contentItems[0]
              ?.bibliographyContentId ?? 0
          )
        } else {
          this.openModalBibliographySearchResultContent()
        }
      }
    })
  }

  openModalBibliographySearchResult(onBackResult?: () => void) {
    this.$modalBibliographySearchResult.open({
      isSelect: true,
      onBackCondition: () => {
        this.openModalBibliographySearchCondition(true)
      },
      onBackResult,
      onTitle: (bibliographyFullIdWithMarcNo: BibliographyFullIdWithMarcNo) => {
        this.openModalBibliographyDetail(
          true,
          bibliographyFullIdWithMarcNo.prefix,
          bibliographyFullIdWithMarcNo.id ?? 0,
          () => {
            this.openModalBibliographySearchResult(onBackResult)
          }
        )
      },
      onSelect: (
        bibliographyFullIdsWithMarcNo: BibliographyFullIdWithMarcNo[]
      ) => {
        if (
          bibliographyFullIdsWithMarcNo.length === 1 &&
          bibliographyFullIdsWithMarcNo[0].prefix === Prefix.Set
        ) {
          modalBibliographySearchResultStore.close()

          this.openModalBibliographyDetail(
            true,
            bibliographyFullIdsWithMarcNo[0].prefix,
            bibliographyFullIdsWithMarcNo[0].id ?? 0,
            () => {
              this.openModalBibliographySearchResult(onBackResult)
            }
          )
        } else {
          this.validateSelectBibliographyId(bibliographyFullIdsWithMarcNo)
        }
      }
    })
  }

  openModalBibliographySearchResultAuthority(): void {
    this.$modalBibliographySearchResultAuthority.open({
      onBackCondition: () => {
        this.openModalBibliographySearchCondition(true)
      },
      onSearch: () => {
        if (
          modalBibliographySearchStore.authoritySearchType ===
          AuthoritySearchType.ContentAuthor
        ) {
          if (modalBibliographySearchStore.contentItems.length === 1) {
            this.openModalBibliographyDetail(
              true,
              modalBibliographySearchStore.contentItems[0].prefix,
              modalBibliographySearchStore.contentItems[0]?.bibliographyId ?? 0,
              this.openModalBibliographySearchResultAuthority
            )
          } else {
            this.openModalBibliographySearchResultContent()
          }
        } else if (this.isHitOneSearchResults) {
          this.openModalBibliographyDetail(
            true,
            this.searchResults[0].prefix,
            this.searchResults[0]?.bibliographyId ?? 0,
            this.openModalBibliographySearchResultAuthority
          )
        } else {
          this.openModalBibliographySearchResult(
            this.openModalBibliographySearchResultAuthority
          )
        }
      }
    })
  }

  openModalBibliographySearchResultContent(): void {
    this.$modalBibliographySearchResultContent.open({
      onBackCondition: () => {
        this.openModalBibliographySearchCondition(true)
      },
      onBackResult: this.openModalBibliographySearchResultAuthority,
      onSelectContent: (
        prefix: Prefix,
        bibliographyRealId: number,
        bibliographyContentId: number
      ) => {
        this.openModalBibliographyDetail(
          true,
          prefix,
          bibliographyRealId,
          this.openModalBibliographySearchResultContent,
          '',
          bibliographyContentId
        )
      }
    })
  }

  openModalBibliographyDetail(
    isBibliographySelectProcess: boolean,
    prefix: Prefix,
    bibliographyId: number,
    onBackResult: () => void,
    marcNo?: string,
    bibliographyContentId?: number
  ): void {
    if (prefix === Prefix.Real) {
      this.openModalBibliographyDetailReal(
        isBibliographySelectProcess,
        bibliographyId,
        modalBibliographySearchStore.contentItems.length > 0
          ? BibliographyDetailRealTabType.Content
          : BibliographyDetailRealTabType.Collection,
        onBackResult,
        marcNo,
        bibliographyContentId
      )
      return
    }
    this.openModalBibliographyDetailSet(
      isBibliographySelectProcess,
      bibliographyId,
      BibliographyDetailSetTabType.Volume,
      onBackResult
    )
  }

  openModalBibliographyDetailReal(
    isBibliographySelectProcess: boolean,
    bibliographyRealId: number,
    tabType: BibliographyDetailRealTabType,
    onBackResult: () => void,
    marcNo?: string,
    bibliographyContentId?: number
  ): void {
    this.$modalBibliographyDetailReal.open({
      isBibliographySelectProcess,
      bibliographyRealId,
      marcNo,
      tabType,
      bibliographyContentId,
      onBackCondition: () => {
        this.openModalBibliographySearchCondition(true)
      },
      onBackResult,
      onSelect: (value: SelectBibliographyDetailReal) =>
        this.validateSelectBibliographyId([
          {
            prefix: value.prefix,
            id: value.bibliographyId,
            marcNo: value.marcNo
          }
        ]),
      onToggleSet: (
        bibliographyId: number,
        tabType: BibliographyDetailSetTabType
      ) => {
        this.openModalBibliographyDetailSet(
          true,
          bibliographyId,
          tabType,
          onBackResult
        )
      }
    })
  }

  openModalBibliographyDetailSet(
    isBibliographySelectProcess: boolean,
    bibliographySetId: number,
    tabType: BibliographyDetailSetTabType,
    onBackResult: () => void
  ): void {
    this.$modalBibliographyDetailSet.open({
      isBibliographySelectProcess,
      bibliographySetId,
      tabType,
      onBackCondition: () => {
        this.openModalBibliographySearchCondition(true)
      },
      onBackResult,
      onSelect: (obj: {
        bibliographyFullId: BibliographyFullId
        selectedBibliographyRealId: number
      }) =>
        this.validateSelectBibliographyId([
          {
            prefix: Prefix.Real,
            id: obj.selectedBibliographyRealId,
            marcNo: ''
          }
        ]),
      onToggleReal: (
        bibliographyId: number,
        tabType: BibliographyDetailRealTabType
      ) => {
        this.openModalBibliographyDetailReal(
          isBibliographySelectProcess,
          bibliographyId,
          tabType,
          onBackResult
        )
      }
    })
  }
}
